import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

// Components
import DocumentGroupEdit from "./DocumentGroupEdit";

// utils
import { handleKeyPress } from "../../../utils/forms/inputHandling";

// Make the wrapped element sortable
const SortableItem = SortableElement(DocumentGroupEdit);

export default SortableContainer(props => {
	const { groups } = props;

	return (
		<div className="group-list">
			{groups.length ? (
				groups.map((group, i) => (
					<SortableItem
						key={"group" + group.id}
						index={i}
						group={group}
						changeGroupMinify={props.changeGroupMinify}
						handleTitleChange={e => props.handleTitleChange(e, i)}
						updateLocalStateFromProps={props.updateLocalStateFromProps}
						handleKeyPressTitle={e => handleKeyPress(e, props.saveGroupTitle, group)}
						saveGroupTitle={props.saveGroupTitle}
						deleteGroup={props.deleteGroup}
						updateFileTitle={props.updateFileTitle}
						handleKeyPressFile={(e, fileIndex) =>
							handleKeyPress(e, props.saveFileTitle, {
								group,
								fileIndex
							})
						}
						saveFileTitle={props.saveFileTitle}
						deleteFile={props.deleteFile}
						onSortEnd={({ oldIndex, newIndex }) =>
							props.onSortEndFiles(oldIndex, newIndex, i)
						}
					/>
				))
			) : (
				<div className="pt1 pb1">No Training Document groups yet!</div>
			)}
		</div>
	);
});



// WEBPACK FOOTER //
// ./src/components/admin/training-documents/SortableGroupList.js